import { defineStore } from 'pinia'
import { ref } from "vue"

export const useLoadingStore = defineStore( 'loadingStore', () => {
  const loading = ref( 0 )

  function incrementLoading() {
    loading.value = loading.value + 1
  }

  function decrementLoading() {
    loading.value = loading.value - 1
  }

  function isLoading() {
    return loading.value > 0
  }

  return { loading, incrementLoading, decrementLoading, isLoading }
})